<script lang="ts" setup>
import model from '@/ts/model';
import cookieHelper from '@/ts/utils/cookie-helper';
import { getLangText } from '@/ts/utils/utils';
import { navigateTo } from '@/ts/management/view-navigation-management';
import Btn from './btn.vue';
function onAccept(){
    model.cookiesAccepted = true;
    cookieHelper.set('cookie_law_informed', '1', 365);
}
</script>

<template>
    <template v-if="!model.cookiesAccepted">
        <div class="cookie-law-popup" v-mobile>
            <div class="message">
                {{ getLangText('CookieLawMsg') }} <a href="#" @click.prevent.stop="navigateTo('cookies-policy', {userInteraction: true})">{{ getLangText('LearnMoreLabel') }}</a>
            </div>
            <btn :skin="'primary'" @click="onAccept()">{{ getLangText('AcceptLabel') }}</btn>
        </div>
    </template>
</template>

<style lang="scss">
@use '@/scss/shared';
.cookie-law-popup{
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    bottom: 10px;
    left:0;
    z-index: 400;
    width: 100%;
    pointer-events: none;
    &[data-mobile]{
        bottom: 100px;
    }
    & > .message{
        background-color: #fff;
        border-radius: 15px;
        width: 90%;
        max-width: 500px;
        padding: 10px;
        margin-bottom: 10px;
        font-weight: 600;
        box-sizing: border-box;
        @include shared.site() using($site-key){
            color: shared.theme-color("primary_3", $site-key);
            border: 2px solid shared.theme-color("comp3_3", $site-key);
        }
        @include shared.dashed-link('primary_3');
    }
    & > *{
        pointer-events: all;
    }
}
</style>